const $ = jQuery.noConflict();

'use strict';
const FormHelpers = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	strCF7Holder: '.js-cf7-holder',
	strForm: '.wpcf7-form',
	strTriggerURL: '#wpcf7-f13-o1',
	classSent: 'form-is-sent',
	classInvalid: 'invalid',
	classSpan: 'span',


	/** @description Initialize */
	init: function() {
		this.checkIfIE();
		this.afterFormSubmit();
		$('input[type=number]').on('mousewheel', function(e) {
			$(e.target).blur();
		});
		$('.mc4wp-checkbox input').on('change', function() {
			if(this.checked === true) {
				$(this).parent().addClass('is-checked');
			} else {
				$(this).parent().removeClass('is-checked');
			}
		});

		$(document).ready(function(){
			$('.ginput_container_number input').keypress(validateNumber);
		});

		function validateNumber(event) {
			const key = window.event ? event.keyCode : event.which;
			if (event.keyCode === 8 || event.keyCode === 46) {
				return true;
			} else if (key < 48 || key > 57) {
				return false;
			} else {
				return true;
			}
		}

		// limit post code to 5
		$('#gform_next_button_2_12').on('click', ()=> {
			setTimeout(()=>{
				if ($('#gform_page_2_2').css('display') !== 'none') {
					const maxChars = 5;
					$('#input_2_105').keydown(function() {
						if ($(this).val().length >= maxChars) {
							$(this).val($(this).val().substr(0, maxChars));
						}
					});

					$('#input_2_105').keyup(function() {
						if ($(this).val().length >= maxChars) {
							$(this).val($(this).val().substr(0, maxChars));
						}
					});
				}
			}, 1000);
		});
	},

	/**
	 * @description CF7 after submit popup trigger. Structure-example ( https://www.dropbox.com/s/oyj5revbgwigzxr/download.jpg?dl=0 )
	 * @example Global.functions.afterFormSubmit('.js-cf7-holder', 'form-is-sent', 8000);
	 * @param {string} formHolder - form holder class (recommended/default is '.js-cf7-holder')
	 * @param {string} sentClass - class added to form parent to trigger popup (default is 'form-is-sent')
	 * @param {number} delay - delay time before sentClass is removed (default delay time is 5000ms)
	 */
	afterFormSubmit: (formHolder = '.js-cf7-holder', sentClass = 'form-is-sent', delay = 5000) => {
		document.addEventListener('wpcf7mailsent', (e) => {
			const formId = e.detail.id;

			$(`#${formId}`).parents(formHolder).addClass(sentClass);
			$('.sent').parent().parent().parent().parent().addClass(sentClass);

			setTimeout(() => {
				$(formHolder).removeClass(sentClass);
				$('.sent').parent().parent().parent().parent().removeClass(sentClass);
				$('.cf7-holder__popup').removeClass('form-is-sent');
			}, delay);
		}, false);
	},
	//If user use Internet Explorer this is custom trigger for Thank you msg for CF7
	checkIfIE() {
		const url = window.location.href;
		const splitUrl = url.split('/').includes(FormHelpers.strTriggerURL);
		if (splitUrl && (!$(FormHelpers.strForm).hasClass(FormHelpers.classInvalid))) {
			$(FormHelpers.strForm).parents(FormHelpers.strCF7Holder).addClass(FormHelpers.classSent);
			setTimeout(() => {
				$(FormHelpers.strCF7Holder).removeClass(FormHelpers.classSent);
			}, 5000);
		}
	}
};

export default FormHelpers;